
import React, { useEffect, useState } from 'react';
import '../../common/css/reissueRequest.css';
import EmdReservation from './reservationNumber/emdReservation';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';

function EmdRequestPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [isCheck, setIsCheck] = useState(true);
    const [regAgentName, setRegAgentName] = useState('');
    const [regAgentPhone, setRegAgentPhone] = useState('');
    const [reservations, setReservations] = useState([
        {
            reqGubun: 'EMD',
            air_pnr: '',
            tkt_number: '',
            org_flight: '',
            new_flight: '',
            tkt_email_address: '',
            freeMemo: '',
        },
    ]);

    useEffect(() => {
        const axiosData = async () => {
            try {
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/emd/info`,
                    {
                        withCredentials: true,
                    },
                );
                setRegAgentName(response.data.userName);
                setRegAgentPhone(response.data.userPhone);
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const reservationAdd = () => {
        setReservations([
            ...reservations,
            {
                reqGubun: '',
                air_pnr: '',
                tkt_number: '',
                org_flight: '',
                new_flight: '',
                tkt_email_address: '',
                freeMemo: '',
            },
        ]);
    };

    // 예약 삭제
    const reservationRemove = () => {
        if (reservations.length > 1) {
            setReservations(reservations.slice(0, -1));
        }
    };

    // 입력 필드 변경 시 상태 업데이트
    const handleChange = (index, field, value) => {
        setReservations(
            reservations.map((reservation, i) =>
                i === index ? { ...reservation, [field]: value } : reservation,
            ),
        );
    };

    const handleSubmit = async () => {
        try {
            for (let i = 0; i < reservations.length; i++) {
                console.log(reservations[i]);
                if (reservations[i].reqGubun !== 'EMD') {
                    setModalContent('EMD REASSOCIATE 요청만 가능합니다.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                }
                else if (reservations[i].air_pnr === '') {
                    setModalContent('항공사 예약번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_number === '') {
                    setModalContent('탑승객명을 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].org_flight === '') {
                    setModalContent('티켓번호를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].new_flight === '') {
                    setModalContent('요청 EMD를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                } else if (reservations[i].tkt_email_address === '') {
                    setModalContent('좌석번호 / 편명 및 날짜를 입력해주세요.');
                    setModalAction(() => () => setSaveStatus(true));
                    setSaveStatus(false);
                    return;
                }
            }

            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            await axios.post(
                `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/emd/request`,
                { reservations, isCheck },
                {
                    withCredentials: true,
                },
            );

            window.location.href = '/service/emdticketlist';

        } catch (error) {
            setModalContent(error.response.data.message);
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };
    return (
        <div id='contents' className='contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>EMD REASSOCIATE 요청</div>
                    <div>요청하기</div>
                </div>
            </div>
            <div className='page_hgroup'>
                <h2 className='title'>EMD REASSOCIATE 요청</h2>
            </div>

            <div className='table_wrap mb40'>
                <table
                    className='table_style4 bdt mb70'
                    cellPadding='0'
                    cellSpacing='0'
                    id='airCertInfoTbl'
                >
                    <colgroup>
                        <col style={{ width: '190px' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <p className='essential'>담당자</p>
                            </th>
                            <td colSpan='3'>{regAgentName}</td>
                        </tr>
                        <tr>
                            <th>
                                <p className='essential'>휴대폰 번호</p>
                            </th>
                            <td colSpan='3'>
                                {regAgentPhone}
                                <label name='agreeSendSNS'>
                                    <input
                                        type='checkbox'
                                        name='agreeSendSNS'
                                        id='agreeSendSNS'
                                        className='agreeSendSNSInput'
                                        checked={isCheck}
                                        onClick={() => setIsCheck(!isCheck)}
                                    />
                                    답변등록 시 SMS 전송
                                </label>
                                <a className='editPhoneNum' href='/mypage'>
                                    (&nbsp;&nbsp;<i class='fa-solid fa-mobile-screen-button'></i>
                                    &nbsp;&nbsp;담당자 휴대폰번호 수정&nbsp;&nbsp;)
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='btn_area reissue_area'>
                    <input
                        type='button'
                        id='plusPnrNum'
                        value='+ 예약번호 추가'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationAdd}
                    />
                    <input
                        type='button'
                        id='minPnrNum'
                        value='- 예약번호 삭제'
                        className='btn36 red sendAuthNumY mo-mt-btn'
                        style={{ height: '45px', lineHeight: 'unset' }}
                        onClick={reservationRemove}
                    />
                </div>
                {reservations.map((data, index) => (
                    <EmdReservation
                        num={index}
                        data={data}
                        key={index}
                        handleChange={handleChange}
                    />
                ))}
            </div>

            <div className='btn_area'>
                <input
                    type='button'
                    id='sendRequest'
                    value='REASSO 요청하기'
                    onClick={handleSubmit}
                    className='btn46 blue'
                    style={{ width: '260px' }}
                />
            </div>
            <div class='title_wrap mt70' style={{ justifyContent: 'flex-start' }}>
                <h4>유의 사항</h4>
            </div>
            <table class='table_style3 bdt' cellpadding='0' cellspacing='0' id='privateInfoTbl'>
                <colgroup>
                    <col style={{ width: '100%' }} />
                </colgroup>
                <tbody>
                    <tr>
                        {/*prettier-ignore */}
                        <td className='infoTable' style={{padding:'10px'}}>
                            <strong className='fontWeight red'>※ EMD REASSOCIATE는 EXTRA LEGROOM 좌석과 FORWARD SEAT에 한해 요청 가능합니다. 단, AISLE SEAT은 구매 후 재지정이 불가합니다.</strong><br />
                            <br />
                            <strong>1. 구매한 EMD 좌석은 노선 변경 및 타인 양도가 불가합니다.</strong><br />
                            <strong>2. NO-SHOW 발생 시, 기존에 구매한 좌석은 효력을 상실합니다.</strong><br />
                            <strong>3. 재발행 시 구매한 동일 카테고리 내 좌석으로만 변경이 가능합니다.(AISLE SEAT 제외)</strong><br />
                            <strong>4. 비상구 좌석은 신체 건강한 만 15세 이상 성인에 한해 지정 가능합니다.(유/소아 동반 승객 및 휠체어 신청 승객 지정 불가)</strong><br />
                            <strong>5. 본 REASSOCIATE 요청으로 좌석 연결이 완료된 후에도, 지정된 좌석 번호는 운항 및 안전상의 이유, 관련 법규에 따라 탑승 후 변경될 수 있습니다.</strong><br />
                        </td>
                    </tr>
                </tbody>
            </table>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default EmdRequestPage;
